import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/changelog",
      },
      queries: [],
    }),
    [],
  );
}

export const useChangelogPageNavigator = createPageNavigator<void>({
  useNavigator,
});
